/*!
  Mobile product gallery dots for the native scroll-snap slider.
*/
(function () {
  const SELECTORS = {
    gallery: 'product-images.product__images--mobile-slider',
    slides: '[data-product-media-list]',
    slide: '[data-slide]',
    dots: '[data-product-media-dot]',
  };

  const SELECTED_CLASS = 'is-selected';

  function initGalleryDots(gallery) {
    const slides = gallery.querySelector(SELECTORS.slides);
    const dots = gallery.querySelectorAll(SELECTORS.dots);
    const slideItems = slides ? slides.querySelectorAll(SELECTORS.slide) : [];

    if (!slides || dots.length < 2 || slideItems.length < 2) return;
    if (gallery.dataset.galleryDotsReady === 'true') return;

    gallery.dataset.galleryDotsReady = 'true';

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle(SELECTED_CLASS, i === index);
      });
    };

    const updateFromScroll = () => {
      const width = slides.clientWidth || 1;
      const index = Math.max(0, Math.min(dots.length - 1, Math.round(slides.scrollLeft / width)));
      setActiveDot(index);
    };

    slides.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(updateFromScroll);
      },
      { passive: true }
    );

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slides.scrollTo({
          left: index * slides.clientWidth,
          behavior: 'smooth',
        });
        setActiveDot(index);
      });
    });

    updateFromScroll();
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.gallery).forEach(initGalleryDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('theme:variant-gallery:updated', (event) => {
    const gallery = event.detail?.gallery;
    if (gallery) {
      delete gallery.dataset.galleryDotsReady;
      initGalleryDots(gallery);
      return;
    }
    initAll();
  });
})();
